export default "__VITE_ASSET__a08c76bd__"